module.exports = __webpack_public_path__ + "static/media/database.6f575647.svg";